// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"8":"73892c74ec6d372ffdb2","482":"908f8d1135476405e8f2","676":"c094d31ad8f244c7b96f","880":"a81be3f508b94f5ccdbe"}[chunkId] + ".chunk.js";
};